import { actions } from "./actions";
import { agentKnowledge } from "./agent-knowledge";
import { agentSettings } from "./agent-settings";
import { agents } from "./agents";
import { evaluations } from "./evaluations";
import { playground } from "./playground";

/** Build console screens (P6 group `build`). One file per screen. */
export const build = {
  planGate: {
    title: "{{feature}} needs a higher plan",
    badge: "Plan feature",
    body: "Your current plan doesn't include this. Upgrade to unlock it — your settings are kept.",
    upgrade: "Compare plans",
  },
  status: { live: "Live", paused: "Paused", draft: "Draft" },
  time: {
    now: "just now",
    minutes_one: "{{count}} minute ago",
    minutes_other: "{{count}} minutes ago",
    hours_one: "{{count}} hour ago",
    hours_other: "{{count}} hours ago",
    yesterday: "Yesterday",
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
    slack: "Slack",
    teams: "Teams",
  },
  loadError: "This page couldn't load.",
  loadErrorBody: "Check your connection and try again. Nothing was lost.",
  noPermission: "You don't have permission to change this",
  readOnly: "Read-only during a support session",
  noAgent: "Choose an agent first",
  noAgentBody: "This page belongs to an agent. Pick one from the agents list.",
  goToAgents: "Go to agents",
  agents,
  agentKnowledge,
  agentSettings,
  playground,
  actions,
  evaluations,
} as const;
